<template>
  <q-layout view="lhh Lpr lff" style="" >
    <div id="" v-if="$route.name !='transaction'&& $route.name !='onlineRedemption' && $route.name!='AHAM Login'&&$route.name!='AHAM Login Checking' && $route.name !='IAccessResetPage'">
    <q-header class="transparent" style="height: 78px !important;">
      
      <div class="row" style="background: #355dc4; position: fixed; width: 100%; height: 78px !important;">
        <div class="col-xs-12 col-md-9 q-px-md q-py-xs" style="margin-top:0; margin-right:auto; margin-bottom: 0; margin-left:auto; align-self: center;"> 
          <div class="row" >
            <div class="col col-sm col-md col-xs" >
              <img :src='companyLogo' style="float: left; image-rendering: auto; max-width: 200px; max-height: 70px;" class="q-py-sm"/>
            </div> 
            <!-- <div  class="col-3 text-right q-pt-lg q-pr-md">
              <q-item-label class="text-subtitle2 text-white text-center">EPF AFFIN HWANG ASSET MANAGEMENT ONLINE</q-item-label>
            </div> -->
            <div v-if="$route.name==='Switching'||$route.name==='Redemption'||$route.name==='Investment'" style="margin-left:5px;" class="col-sm-4 col-md-4 col-xs-6 q-pt-md text-right">
         
              <q-btn flat outline class="logoutbutton" icon-right="logout" label="Sign Out" @click="logout()" style="color: white"></q-btn>
              
            </div>
            <div id="userid" style="display:none;">{{StoreStateAO.PersonalInformation.NRIC}}</div>
             <Nav  v-if="$route.name=='error'" />
          </div>
        </div>
      </div>

      </q-header>
      <q-footer class="AppFooter" style="background-color:rgba(65,65,65,1); ">
      
        <FooterComponent/>
      
    </q-footer>
    <!-- <div class="" style="background: #F4F4FA; height: 90%;"> -->
        
      <q-page-container style="background: #F4F4FA; padding-top: 78px !important; font-family: 'Poppins', sans-serif !important; padding-bottom: 0px;">
        <router-view  />
      </q-page-container>
    <!-- </div> -->
    
    </div>
    
    
    <!--router layout to call login page-->
    <router-view id="login" v-if="$route.name =='AHAM Login' || $route.name =='AHAM Login Checking'|| $route.name =='IAccessResetPage'" />

      <router-view id="onlineRedemption"  v-if="$route.name =='transaction'||$route.name =='onlineRedemption'" />

 
  </q-layout>
</template>
<script>

import { mapActions } from 'vuex';
import timer from '@/components/timer'
import store from '../store';

import Nav from "@/components/Nav"
import FooterComponent from '@/components/FooterComponent.vue'
export default {
  name: 'LayoutDefault',
components : {
        Nav,
        timer,
        FooterComponent
    },
     data() {
        return {
        StoreStateAO : store.state.AOD,
        leftDrawerOpen: false,
        userName: '',
        
            StoreStateLogin: store.state.Login,
        companyLogo: this.$store.getters.getCompanyLogo('white')
      }

  },  methods:{
         ...mapActions([
            "triggerLogout",
        ]),
      logout:function(){
         this.triggerLogout();
      }

  },
  mounted(){
    //alert('default')
    
  } 
}
</script>
<style >
@media print {
    .Acknowlegdement{
        display : block;
    }
    .q-stepper__header,.logoutbutton{
        display : none;
    }
    .AckBtn{
        display : none;
    }
}
</style>
